const stickySections = document.querySelectorAll('.sticky_modie');

let lastScrollY = window.scrollY;

window.addEventListener('scroll', () => {
  const currentScrollY = window.scrollY;

  stickySections.forEach(section => {
    const parent = section.parentElement;
    if (!parent) return;

     if (currentScrollY > 400) {

          parent.classList.add('scrolled');
          section.classList.add('reset-btm-padding');
          
         if (currentScrollY > lastScrollY) {
            // Scrolling down
            parent.classList.remove('sticky-parent-hide');
            parent.classList.add('sticky-parent-show');
          } else if (currentScrollY < lastScrollY) {
            // Scrolling up
            parent.classList.add('sticky-parent-hide');
            parent.classList.remove('sticky-parent-show');
          }

      } else {
        parent.classList.remove('scrolled');
        parent.classList.remove('sticky-parent-hide');
        section.classList.remove('reset-btm-padding');
      }
  });

  lastScrollY = currentScrollY;
});
